/**
 * OMS API loader for zh-tabs-product-list.
 * POST custom-collection-products → client-side cards (same markup as former custom.js).
 */
(function (global) {
  var DEFAULT_ENDPOINT = "https://app.zenheart.world/api/shopify/custom-collection-products";
  var DEFAULT_COLLECTION_ID = "324635558071";
  var COLLECTION_ID_QUERY_KEYS = ["collection_id", "collectionId"];
  var API_TIMEOUT_MS = 20000;
  var API_MAX_RETRY = 1;
  var CACHE_TTL_MS = 120000;
  var EAGER_IMAGE_COUNT = 4;
  var IMAGE_FETCH_WIDTH_DESKTOP = 600;
  var IMAGE_FETCH_WIDTH_MOBILE = 420;
  var IMAGE_LAZY_ROOT_MARGIN = 900;
  var IMAGE_LAZY_CONCURRENCY = 3;
  var EARLY_PAGE_SIZE_FALLBACK = 12;

  var inflightRequests = {};
  var earlyFirstPagePrefetch = {
    apiUrl: "",
    done: false,
    promise: null,
    payload: null
  };
  var imageLoaderState = {
    observer: null,
    queue: [],
    inflight: 0
  };

  function getByPath(source, path) {
    if (!path) return source;
    var keys = String(path).split(".");
    var cursor = source;
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      if (!key) continue;
      if (cursor == null || typeof cursor !== "object" || !(key in cursor)) return undefined;
      cursor = cursor[key];
    }
    return cursor;
  }

  function toText(value) {
    if (value == null) return "";
    return String(value);
  }

  function escapeHtml(value) {
    return toText(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function withImageWidth(url, width) {
    if (!url) return "";
    try {
      var u = new URL(url, window.location.origin);
      if (!u.searchParams.has("width")) u.searchParams.set("width", String(width));
      return u.toString();
    } catch (e) {
      return url;
    }
  }

  function getImageFetchWidth() {
    return window.innerWidth <= 768 ? IMAGE_FETCH_WIDTH_MOBILE : IMAGE_FETCH_WIDTH_DESKTOP;
  }

  function normalizeMoneyAmount(value) {
    var normalized = value;
    if (typeof value === "string") normalized = value.replace(/[^\d.-]/g, "");
    var raw = Number(normalized || 0);
    if (!isFinite(raw)) raw = 0;
    // /products/{handle}.js often returns integer cents; OMS returns decimal strings like "1188.00".
    var isDecimalString = typeof normalized === "string" && normalized.indexOf(".") !== -1;
    if (!isDecimalString && typeof normalized === "number" && Number.isInteger(normalized)) {
      return raw / 100;
    }
    return raw;
  }

  function getMoneyFormat() {
    if (typeof window !== "undefined" && window.T4Sconfigs && window.T4Sconfigs.moneyFormat) {
      return window.T4Sconfigs.moneyFormat;
    }
    var root = document.querySelector("[data-zh-tabs-root][data-money-format]");
    if (root) return root.getAttribute("data-money-format");
    return null;
  }

  function formatMoney(value) {
    var amount = normalizeMoneyAmount(value);
    var format = getMoneyFormat();

    if (typeof Shopify !== "undefined" && typeof Shopify.formatMoney === "function") {
      try {
        return Shopify.formatMoney(Math.round(amount * 100), format || undefined);
      } catch (e) {}
    }

    if (format) {
      var amountStr = amount.toFixed(2);
      var amountNoDec = String(Math.round(amount));
      var withComma = function (str) {
        return String(str).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      };
      return String(format)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma(amountStr))
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, withComma(amountNoDec))
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDec)
        .replace(/\{\{\s*amount\s*\}\}/g, amountStr);
    }

    return amount.toFixed(2);
  }

  function formatMoneyHtml(value) {
    return formatMoney(value);
  }

  function buildCardHtml(product, options) {
    var eagerImage = !!(options && options.eagerImage);
    var omitHoverImage = !!(options && options.omitHoverImage);
    var variants = [];
    if (Array.isArray(product && product.variants)) variants = product.variants;
    else if (product && product.variants && Array.isArray(product.variants.nodes)) variants = product.variants.nodes;

    var firstVariant = variants.length ? variants[0] : null;
    var pricedVariants = variants.filter(function (v) {
      return v && v.price != null && isFinite(Number(v.price));
    });
    var availablePricedVariants = pricedVariants.filter(function (v) {
      return v.availableForSale === true || v.available === true;
    });
    var variantPool = availablePricedVariants.length ? availablePricedVariants : pricedVariants;
    var minPriceVariant = null;
    if (variantPool.length) {
      minPriceVariant = variantPool.reduce(function (min, current) {
        if (!min) return current;
        return Number(current.price) < Number(min.price) ? current : min;
      }, null);
    }

    var mediaNodes = product && product.media && Array.isArray(product.media.nodes) ? product.media.nodes : [];
    var imageNode =
      product && product.featuredMedia && product.featuredMedia.preview && product.featuredMedia.preview.image
        ? product.featuredMedia.preview.image
        : mediaNodes[0] && mediaNodes[0].preview
          ? mediaNodes[0].preview.image
          : null;
    var hoverNode = mediaNodes[1] && mediaNodes[1].preview ? mediaNodes[1].preview.image : null;
    var image =
      imageNode && imageNode.url
        ? imageNode.url
        : product && product.featuredImage
          ? product.featuredImage
          : product && product.featured_image
            ? product.featured_image
            : "";
    var secondImage = hoverNode && hoverNode.url ? hoverNode.url : "";
    var imageFetchWidth = getImageFetchWidth();
    image = withImageWidth(image, imageFetchWidth);
    secondImage = withImageWidth(secondImage, imageFetchWidth);
    var imageWidth = imageNode && imageNode.width ? Number(imageNode.width) : 1000;
    var imageHeight = imageNode && imageNode.height ? Number(imageNode.height) : 1000;
    if (!isFinite(imageWidth) || imageWidth <= 0) imageWidth = 1000;
    if (!isFinite(imageHeight) || imageHeight <= 0) imageHeight = 1000;
    var hoverWidth = hoverNode && hoverNode.width ? Number(hoverNode.width) : imageWidth;
    var hoverHeight = hoverNode && hoverNode.height ? Number(hoverNode.height) : imageHeight;
    var title = product && product.title ? product.title : "";
    var handle = product && product.handle ? product.handle : "";
    var productId = product && product.id != null ? String(product.id).replace(/\D/g, "") : "";
    var url =
      product && (product.url || product.onlineStoreUrl)
        ? product.url || product.onlineStoreUrl
        : handle
          ? "/products/" + handle
          : "#";
    var variantPrice =
      minPriceVariant && minPriceVariant.price != null
        ? minPriceVariant.price
        : firstVariant && firstVariant.price != null
          ? firstVariant.price
          : null;
    var compareAtPriceSource =
      minPriceVariant && minPriceVariant.compareAtPrice != null
        ? minPriceVariant.compareAtPrice
        : firstVariant && firstVariant.compareAtPrice != null
          ? firstVariant.compareAtPrice
          : null;
    var fallbackPrice = product && product.price != null ? product.price : null;
    var priceSource = variantPrice != null ? variantPrice : fallbackPrice;
    var price = priceSource != null ? formatMoneyHtml(priceSource) : "";
    var compareAtPrice = compareAtPriceSource != null ? formatMoneyHtml(compareAtPriceSource) : "";
    var showCompare = !!compareAtPrice && Number(compareAtPriceSource) > Number(priceSource || 0);
    var ratio = (imageWidth / imageHeight).toFixed(4);

    var mainImageHtml = "";
    if (image) {
      mainImageHtml =
        '<img data-pr-img class="t4s-product-main-img" ' +
        (eagerImage
          ? 'loading="eager" fetchpriority="high" src="' + escapeHtml(image) + '" '
          : 'loading="lazy" src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" data-ccp-src="' +
            escapeHtml(image) +
            '" ') +
        'width="' +
        imageWidth +
        '" height="' +
        imageHeight +
        '" alt="' +
        escapeHtml(title) +
        '">';
    }
    var hoverImageHtml =
      !omitHoverImage && secondImage
        ? '<img data-pr-img2 class="t4s-product-hover-img" loading="lazy" src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" data-ccp-hover-src="' +
          escapeHtml(secondImage) +
          '" width="' +
          hoverWidth +
          '" height="' +
          hoverHeight +
          '" alt="' +
          escapeHtml(title) +
          '">'
        : "";

    return (
      '<div class="t4s-product t4s-pr-grid t4s-pr-style1 t4s-col-item" data-zh-tabs-product-item data-product-id="' +
      escapeHtml(productId) +
      '">' +
      '<div class="t4s-product-wrapper">' +
      '<div class="t4s-product-inner t4s-pr t4s-oh">' +
      '<div class="t4s-product-img t4s_ratio" style="--aspect-ratioapt:' +
      ratio +
      ';">' +
      '<a class="t4s-d-block" href="' +
      escapeHtml(url) +
      '">' +
      mainImageHtml +
      hoverImageHtml +
      "</a>" +
      "</div>" +
      '<a class="t4s-full-width-link" href="' +
      escapeHtml(url) +
      '"></a>' +
      "</div>" +
      '<div class="t4s-product-info"><div class="t4s-product-info__inner">' +
      '<h3 class="t4s-product-title"><a href="' +
      escapeHtml(url) +
      '">' +
      escapeHtml(title) +
      "</a></h3>" +
      (price
        ? '<div class="t4s-product-price t4s-product-price--card" data-pr-price data-product-price><ins>' +
          price +
          "</ins>" +
          (showCompare ? '<del class="t4s-price__compare">' + compareAtPrice + "</del>" : "") +
          "</div>"
        : "") +
      "</div></div>" +
      "</div>" +
      "</div>"
    );
  }

  function resolveCollectionIdFromPage(fallback) {
    try {
      var params = new URL(window.location.href).searchParams;
      for (var k = 0; k < COLLECTION_ID_QUERY_KEYS.length; k++) {
        var raw = params.get(COLLECTION_ID_QUERY_KEYS[k]);
        if (raw == null || raw === "") continue;
        var tid = String(raw).trim();
        if (/^\d+$/.test(tid)) return tid;
      }
    } catch (e) {}
    var fb = String(fallback || "").trim();
    if (/^\d+$/.test(fb)) return fb;
    return DEFAULT_COLLECTION_ID;
  }

  function resolveInitialPageSize(fallback) {
    try {
      var raw = new URL(window.location.href).searchParams.get("page_size");
      if (raw != null && raw !== "") {
        var parsed = Number(raw);
        if (isFinite(parsed) && parsed > 0) return Math.floor(parsed);
      }
    } catch (e) {}
    var fb = Number(fallback || EARLY_PAGE_SIZE_FALLBACK);
    return isFinite(fb) && fb > 0 ? fb : EARLY_PAGE_SIZE_FALLBACK;
  }

  function buildApiUrl(panel, page) {
    var endpoint = panel.dataset.apiUrl || DEFAULT_ENDPOINT;
    var collectionId = resolveCollectionIdFromPage(panel.dataset.apiCollectionId);
    if (!collectionId) return "";
    var pageSize = resolveInitialPageSize(panel.dataset.apiPageSize);
    var url = new URL(endpoint, window.location.origin);
    var currentParams = new URL(window.location.href).searchParams;

    function readMulti(paramName) {
      var values = currentParams.getAll(paramName);
      var result = [];
      values.forEach(function (value) {
        if (value == null) return;
        String(value)
          .split(/[,|，]/)
          .map(function (p) {
            return p.trim();
          })
          .filter(Boolean)
          .forEach(function (p) {
            result.push(p);
          });
      });
      return result;
    }

    var pinnedProductId = currentParams.get("p_pid");
    if (pinnedProductId) url.searchParams.set("p_pid", pinnedProductId);

    var tags = readMulti("tag");
    tags.forEach(function (tag) {
      url.searchParams.append("tag", tag);
    });
    if (tags.length) {
      url.searchParams.set("tags", tags.join(","));
      var tagLogic = String(currentParams.get("tag_logic") || currentParams.get("tag_mode") || "or").toLowerCase();
      if (tagLogic !== "and" && tagLogic !== "or") tagLogic = "or";
      url.searchParams.set("tag_logic", tagLogic);
    }
    readMulti("product_type").forEach(function (part) {
      url.searchParams.append("product_type", part);
    });

    url.searchParams.set("collection_id", String(collectionId));
    url.searchParams.set("page", String(page || 1));
    url.searchParams.set("page_size", String(pageSize));
    return url.toString();
  }

  function getCacheKey(apiUrl) {
    return "zh_tabs_cache:" + apiUrl;
  }

  function readCachedPayload(apiUrl) {
    try {
      var raw = sessionStorage.getItem(getCacheKey(apiUrl));
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.ts || !parsed.payload) return null;
      if (Date.now() - parsed.ts > CACHE_TTL_MS) return null;
      return parsed.payload;
    } catch (e) {
      return null;
    }
  }

  function writeCachedPayload(apiUrl, payload) {
    try {
      sessionStorage.setItem(getCacheKey(apiUrl), JSON.stringify({ ts: Date.now(), payload: payload }));
    } catch (e) {}
  }

  function maybeStartEarlyFirstPagePrefetch() {
    if (global.__zhTabsEnableEarlyPrefetch !== true) return;
    if (earlyFirstPagePrefetch.done || earlyFirstPagePrefetch.promise) return;
    var collectionId = resolveCollectionIdFromPage(DEFAULT_COLLECTION_ID);
    var pageSize = resolveInitialPageSize(EARLY_PAGE_SIZE_FALLBACK);
    var apiUrl = buildApiUrl(
      {
        dataset: {
          apiUrl: DEFAULT_ENDPOINT,
          apiCollectionId: collectionId,
          apiPageSize: String(pageSize)
        }
      },
      1
    );
    if (!apiUrl) return;

    earlyFirstPagePrefetch.apiUrl = apiUrl;
    earlyFirstPagePrefetch.promise = fetch(apiUrl, { method: "POST", credentials: "omit", body: "{}" })
      .then(function (response) {
        if (!response.ok) throw new Error("Early prefetch response error: " + response.status);
        return response.json();
      })
      .then(function (payload) {
        earlyFirstPagePrefetch.payload = payload;
        writeCachedPayload(apiUrl, payload);
        return payload;
      })
      .catch(function () {
        return null;
      })
      .finally(function () {
        earlyFirstPagePrefetch.done = true;
      });
  }

  async function readEarlyPrefetchedPayload(apiUrl) {
    if (!apiUrl || earlyFirstPagePrefetch.apiUrl !== apiUrl) return null;
    if (earlyFirstPagePrefetch.payload) return earlyFirstPagePrefetch.payload;
    if (!earlyFirstPagePrefetch.promise) return null;
    try {
      return await earlyFirstPagePrefetch.promise;
    } catch (e) {
      return null;
    }
  }

  function parseInventoryNumber(value) {
    if (value == null || value === "") return null;
    var num = Number(value);
    return isFinite(num) ? num : null;
  }

  function isProductInStock(product) {
    if (!product || typeof product !== "object") return false;
    if (product.availableForSale === false || product.available === false) return false;

    var productLevelInventory = [
      parseInventoryNumber(product.totalInventory),
      parseInventoryNumber(product.inventoryQuantity),
      parseInventoryNumber(product.stock),
      parseInventoryNumber(product.quantityAvailable)
    ];
    for (var i = 0; i < productLevelInventory.length; i++) {
      if (productLevelInventory[i] != null) return productLevelInventory[i] > 0;
    }

    var variants = [];
    if (Array.isArray(product.variants)) variants = product.variants;
    else if (product.variants && Array.isArray(product.variants.nodes)) variants = product.variants.nodes;
    if (!variants.length) {
      if (product.availableForSale === true || product.available === true) return true;
      return false;
    }

    var hasExplicitAvailability = false;
    for (var j = 0; j < variants.length; j++) {
      var variant = variants[j];
      if (!variant || typeof variant !== "object") continue;
      if (variant.availableForSale === true || variant.available === true) return true;
      if (variant.availableForSale === false || variant.available === false) hasExplicitAvailability = true;
      var variantInventory = [
        parseInventoryNumber(variant.quantityAvailable),
        parseInventoryNumber(variant.inventoryQuantity),
        parseInventoryNumber(variant.stock)
      ];
      for (var k = 0; k < variantInventory.length; k++) {
        if (variantInventory[k] != null) {
          hasExplicitAvailability = true;
          if (variantInventory[k] > 0) return true;
        }
      }
    }
    if (hasExplicitAvailability) return false;
    return true;
  }

  function filterDisplayableProducts(products) {
    if (!Array.isArray(products) || !products.length) return [];
    return products.filter(function (product) {
      if (!product || !product.handle) return false;
      var status = toText(product.status);
      status = status ? status.trim().toUpperCase() : "";
      if (status !== "ACTIVE") return false;
      if (product.isArchived === true || product.archived === true) return false;
      if (product.availableForSale === false || product.available === false) return false;
      return isProductInStock(product);
    });
  }

  async function fetchWithTimeout(url, options, timeoutMs) {
    var controller = new AbortController();
    var timer = setTimeout(function () {
      controller.abort();
    }, timeoutMs);
    try {
      return await fetch(url, Object.assign({}, options, { signal: controller.signal }));
    } finally {
      clearTimeout(timer);
    }
  }

  function requestAnimationFrameAsync() {
    return new Promise(function (resolve) {
      requestAnimationFrame(function () {
        resolve();
      });
    });
  }

  function setupLazyImageLoader(rootEl) {
    if (!rootEl) return;
    var lazyImgs = rootEl.querySelectorAll("img[data-ccp-src]");
    if (!lazyImgs.length) return;

    var processQueue = function () {
      while (imageLoaderState.inflight < IMAGE_LAZY_CONCURRENCY && imageLoaderState.queue.length) {
        var img = imageLoaderState.queue.shift();
        if (!img || img.getAttribute("data-ccp-loaded") === "1") continue;
        var src = img.getAttribute("data-ccp-src");
        if (!src) continue;
        imageLoaderState.inflight += 1;
        var done = (function (target) {
          return function () {
            target.setAttribute("data-ccp-loaded", "1");
            imageLoaderState.inflight = Math.max(0, imageLoaderState.inflight - 1);
            setTimeout(processQueue, 20);
          };
        })(img);
        img.addEventListener("load", done, { once: true });
        img.addEventListener("error", done, { once: true });
        img.setAttribute("src", src);
      }
    };

    var enqueueInDomOrder = function (filterReady) {
      var ordered = rootEl.querySelectorAll("img[data-ccp-src]");
      for (var i = 0; i < ordered.length; i++) {
        var img = ordered[i];
        if (img.getAttribute("data-ccp-loaded") === "1") continue;
        if (img.getAttribute("data-ccp-queued") === "1") continue;
        if (filterReady && img.getAttribute("data-ccp-ready") !== "1") continue;
        img.setAttribute("data-ccp-queued", "1");
        imageLoaderState.queue.push(img);
      }
      processQueue();
    };

    if (!("IntersectionObserver" in window)) {
      enqueueInDomOrder(false);
      return;
    }

    if (!imageLoaderState.observer) {
      imageLoaderState.observer = new IntersectionObserver(
        function (entries, observer) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.setAttribute("data-ccp-ready", "1");
            observer.unobserve(entry.target);
          });
          enqueueInDomOrder(true);
        },
        { rootMargin: IMAGE_LAZY_ROOT_MARGIN + "px 0px" }
      );
    }

    for (var j = 0; j < lazyImgs.length; j++) {
      var target = lazyImgs[j];
      if (target.getAttribute("data-ccp-loaded") === "1") continue;
      if (target.getAttribute("data-ccp-observed") === "1") continue;
      target.setAttribute("data-ccp-observed", "1");
      imageLoaderState.observer.observe(target);
    }
  }

  function setEmptyVisible(panel, visible) {
    var empty = panel.querySelector("[data-zh-tabs-empty]");
    var grid = panel.querySelector("[data-zh-tabs-grid]");
    if (empty) {
      if (visible) empty.removeAttribute("hidden");
      else empty.setAttribute("hidden", "");
    }
    if (grid) {
      if (visible) grid.setAttribute("hidden", "");
      else grid.removeAttribute("hidden");
    }
  }

  function clearSkeleton(grid) {
    var skeletons = grid.querySelectorAll(".ccp-skeleton");
    if (!skeletons.length) return;
    grid.innerHTML = "";
  }

  async function renderProducts(grid, products, prioritizeFirstLoad) {
    if (!Array.isArray(products) || !products.length) return 0;
    clearSkeleton(grid);
    var rendered = 0;
    var chunkSize = 4;
    for (var i = 0; i < products.length; i += chunkSize) {
      var batchHtml = "";
      for (var j = i; j < i + chunkSize && j < products.length; j++) {
        var product = products[j];
        if (!product || !product.handle) continue;
        var isFirstBatchCard = prioritizeFirstLoad && rendered < EAGER_IMAGE_COUNT;
        batchHtml += buildCardHtml(product, {
          eagerImage: isFirstBatchCard,
          omitHoverImage: isFirstBatchCard
        });
        rendered += 1;
      }
      if (batchHtml) {
        grid.insertAdjacentHTML("beforeend", batchHtml);
        setupLazyImageLoader(grid);
        await requestAnimationFrameAsync();
      }
    }
    return rendered;
  }

  async function loadNext(panel, ctx) {
    ctx = ctx || {};
    var grid = panel.querySelector("[data-zh-tabs-grid]");
    if (!grid) {
      panel.dataset.hasMore = "false";
      setEmptyVisible(panel, true);
      return;
    }

    var nextPage = Number(panel.dataset.nextPage || "1");
    var isFirstPaint = !grid.querySelector("[data-zh-tabs-product-item]");
    var renderedInThisLoad = 0;

    try {
      while (panel.dataset.hasMore === "true") {
        var api = buildApiUrl(panel, nextPage);
        if (!api) {
          panel.dataset.hasMore = "false";
          break;
        }

        var payload = null;
        if (nextPage === 1) {
          payload = (await readEarlyPrefetchedPayload(api)) || readCachedPayload(api);
        }

        if (!payload) {
          var response = null;
          var attempt = 0;
          var requestKey = api + "|POST";
          var requestTimeout = isFirstPaint ? 0 : API_TIMEOUT_MS;
          while (attempt <= API_MAX_RETRY) {
            try {
              if (inflightRequests[requestKey]) {
                response = await inflightRequests[requestKey];
              } else {
                var fetchOpts = { method: "POST", credentials: "omit", body: "{}" };
                if (ctx.signal) fetchOpts.signal = ctx.signal;
                if (requestTimeout > 0) {
                  inflightRequests[requestKey] = fetchWithTimeout(api, fetchOpts, requestTimeout);
                } else {
                  inflightRequests[requestKey] = fetch(api, fetchOpts);
                }
                response = await inflightRequests[requestKey];
              }
              break;
            } catch (fetchError) {
              attempt += 1;
              if (fetchError && fetchError.name === "AbortError") throw fetchError;
              if (attempt > API_MAX_RETRY) throw fetchError;
            } finally {
              delete inflightRequests[requestKey];
            }
          }
          if (!response.ok) throw new Error("API response error: " + response.status);
          payload = await response.json();
          if (nextPage === 1) writeCachedPayload(api, payload);
        }

        if (Number(payload && payload.code) !== 0) {
          throw new Error("API business error: " + toText(payload && payload.message));
        }

        var products = filterDisplayableProducts(getByPath(payload, "data.products") || []);
        if (products.length) {
          setEmptyVisible(panel, false);
          renderedInThisLoad += await renderProducts(
            grid,
            products,
            isFirstPaint && renderedInThisLoad === 0
          );
        }

        var page = Number(getByPath(payload, "data.page") || nextPage);
        var pageSize = Number(getByPath(payload, "data.pageSize") || panel.dataset.apiPageSize || 12);
        var total = Number(getByPath(payload, "data.total") || 0);
        var hasMore = pageSize > 0 && page * pageSize < total;
        nextPage = page + 1;
        panel.dataset.nextPage = String(nextPage);
        panel.dataset.hasMore = hasMore ? "true" : "false";

        if (products.length > 0 || !hasMore) break;
      }
    } catch (error) {
      if (error && error.name === "AbortError") throw error;
      panel.dataset.hasMore = "false";
      if (!panel.querySelector("[data-zh-tabs-product-item]")) setEmptyVisible(panel, true);
      throw error;
    }

    if (!renderedInThisLoad && !panel.querySelector("[data-zh-tabs-product-item]")) {
      setEmptyVisible(panel, true);
      panel.dataset.hasMore = "false";
    }
  }

  global.ZhTabsApi = {
    loadNext: loadNext,
    setEmptyVisible: setEmptyVisible,
    maybeStartEarlyFirstPagePrefetch: maybeStartEarlyFirstPagePrefetch,
    buildApiUrl: buildApiUrl,
    resolveCollectionIdFromPage: resolveCollectionIdFromPage
  };

  document.addEventListener(
    "mouseenter",
    function (e) {
      var target = e.target;
      if (!target || !target.matches || !target.matches("img[data-ccp-hover-src]")) return;
      if (target.getAttribute("data-ccp-hover-loaded") === "1") return;
      var hoverSrc = target.getAttribute("data-ccp-hover-src");
      if (!hoverSrc) return;
      target.setAttribute("src", hoverSrc);
      target.setAttribute("data-ccp-hover-loaded", "1");
    },
    true
  );

  maybeStartEarlyFirstPagePrefetch();
})(typeof window !== "undefined" ? window : this);
